import { render, staticRenderFns } from "./planCover.vue?vue&type=template&id=bd14ea86&scoped=true&"
import script from "./planCover.vue?vue&type=script&lang=ts&"
export * from "./planCover.vue?vue&type=script&lang=ts&"
import style0 from "./planCover.vue?vue&type=style&index=0&id=bd14ea86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd14ea86",
  null
  
)

export default component.exports